/* BA-25 Camgard sepet çekmecesi: rezervasyon sayacı + Öncelikli Kargo düğmesi.
   Sayaç eski Shrine'daki gibi davranır: çekmece açılınca 05:00'ten geri sayar, kapanınca da sürer;
   çekmece içeriği yenilenince (adet değişimi vb.) 05:00'ten yeniden başlar; 00:00'dan sonra 01:30'a döner. */
(function () {
  if (window.cgCartDrawerReady) return;
  window.cgCartDrawerReady = true;

  const pad = (n) => (n < 10 ? '0' + n : String(n));

  class CgCountdown extends HTMLElement {
    connectedCallback() {
      this.left = parseInt(this.dataset.duration, 10) || 300;
      this.paint();
      const drawer = this.closest('cart-drawer');
      if (drawer && drawer.classList.contains('active')) this.play();
    }
    disconnectedCallback() {
      clearInterval(this.timer);
      this.timer = null;
    }
    paint() {
      this.textContent = pad(Math.floor(this.left / 60)) + ':' + pad(this.left % 60);
    }
    play() {
      if (this.timer) return;
      this.timer = setInterval(() => {
        this.left = this.left > 1 ? this.left - 1 : this.left === 1 ? 0 : 90;
        this.paint();
      }, 1000);
    }
  }
  customElements.define('cg-countdown', CgCountdown);

  // Çekmece açılınca sayacı başlat.
  customElements.whenDefined('cart-drawer').then(() => {
    const C = customElements.get('cart-drawer');
    const open = C.prototype.open;
    C.prototype.open = function () {
      const r = open.apply(this, arguments);
      const t = this.querySelector('cg-countdown');
      if (t) t.play();
      return r;
    };
  });

  // Öncelikli Kargo: açınca 49,90 TL'lik ürün sepete eklenir, kapatınca satır silinir.
  const SECTIONS = 'cart-drawer,cart-icon-bubble';
  const post = (url, body) =>
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(Object.assign(body, { sections: SECTIONS, sections_url: window.location.pathname })),
    }).then((r) => r.json().then((j) => (r.ok ? j : Promise.reject(j))));

  const parse = (html) => new DOMParser().parseFromString(html, 'text/html');

  // Çekmeceyi yeniden açmadan yeniler; odağı düğmeye geri verir ki klavyeyle kullanım sürsün.
  function repaint(sections) {
    const drawer = document.querySelector('cart-drawer');
    const cur = document.getElementById('CartDrawer');
    const next = sections['cart-drawer'] && parse(sections['cart-drawer']).querySelector('#CartDrawer');
    if (drawer && cur && next) {
      cur.innerHTML = next.innerHTML;
      const ov = cur.querySelector('#CartDrawer-Overlay');
      if (ov && typeof drawer.close === 'function') ov.addEventListener('click', drawer.close.bind(drawer));
      const sw = cur.querySelector('[data-cg-prio]');
      const box = cur.querySelector('.drawer__inner');
      if (box && typeof trapFocus === 'function') trapFocus(box, sw || cur.querySelector('.drawer__close'));
    }
    const bubble = document.getElementById('cart-icon-bubble');
    const b = sections['cart-icon-bubble'] && parse(sections['cart-icon-bubble']).querySelector('.shopify-section');
    if (bubble && b) bubble.innerHTML = b.innerHTML;
  }

  document.addEventListener('click', (e) => {
    const sw = e.target.closest('[data-cg-prio]');
    if (!sw || sw.getAttribute('aria-busy') === 'true') return;
    e.preventDefault();
    const on = sw.getAttribute('aria-checked') === 'true';
    sw.setAttribute('aria-busy', 'true');
    sw.setAttribute('aria-checked', on ? 'false' : 'true');
    const req = on
      ? post(window.routes.cart_change_url, { id: sw.dataset.key, quantity: 0 })
      : post(window.routes.cart_add_url + '.js', { items: [{ id: Number(sw.dataset.cgPrio), quantity: 1 }] });
    req
      .then((res) => {
        if (res.sections) repaint(res.sections);
        else window.location.reload();
      })
      .catch(() => {
        sw.setAttribute('aria-checked', on ? 'true' : 'false');
        sw.removeAttribute('aria-busy');
        const err = document.getElementById('CartDrawer-CartErrors');
        if (err) err.textContent = (window.cartStrings && window.cartStrings.error) || 'Bir hata oluştu, lütfen tekrar deneyin.';
      });
  });
})();
